import { firePixel } from "../pixels";
import { urlParam } from "../config";

//Fires the initiateCheckout pixel the first time the visitor touches the
//order form - the moment the page stops being read and starts being filled.
//
//The event is a focus and not a click on purpose: tapping a field, clicking
//it or arriving on it with Tab all end in the same place, and a tap on a
//<select> or a checkbox focuses it too, so one listener covers every way in.
//No field on these pages carries autofocus, and the only focus the libraries
//move themselves - the phone library opening its country search - is already
//behind a tap on the form, so a focus here is always the visitor arriving.
//
//Scoped to .sdk-form, the checkout form the submit flow binds: a field
//somewhere else on the page - a newsletter box, a quiz answer - is not the
//checkout being started.
//
//Once per page. A reload counts again, which is what the CRM's counter
//means; the affiliates' pixels are deduped per transaction on their side.
const FIELDS = "input:not([type=hidden]), select, textarea";
const FORM = ".sdk-form";

export function initiateCheckoutPixel() {
	if (!urlParam("transaction_id")) {
		return;
	}

	const onFocus = (event) => {
		const field = event.target;

		if (!field || typeof field.closest !== "function") {
			return;
		}
		if (!field.closest(FORM) || !field.matches(FIELDS)) {
			return;
		}

		document.removeEventListener("focusin", onFocus, true);
		firePixel("initiateCheckout");
	};

	//Captured, so a field whose own handler stops the event still reports.
	document.addEventListener("focusin", onFocus, true);
}
